module.exports = __webpack_public_path__ + "static/media/599.702(12).69ce986e.pdf";